import { Link } from "react-router-dom";
import { hotTopics, trendingTicker } from "@/mocks/topics";

export default function Ticker() {
  const doubled = [...trendingTicker, ...trendingTicker];

  return (
    <section
      aria-label="实时话题滚动播报"
      className="border-b border-background-200 bg-foreground-950 py-3"
    >
      <div className="mx-auto flex w-full max-w-shell items-center gap-4 overflow-hidden px-4 md:px-8">
        <span className="flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-3 py-1.5 text-xs font-medium text-background-50">
          <i className="ri-flashlight-fill" />
          实时滚动
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="ticker-track flex w-max items-center gap-8">
            {doubled.map((text, index) => {
              const topic = hotTopics[index % hotTopics.length];
              return (
                <Link
                  key={`${text}-${index}`}
                  to={`/topic/${topic.id}`}
                  className="flex shrink-0 items-center gap-2 whitespace-nowrap text-xs text-background-200 transition-colors hover:text-accent-400 md:text-sm"
                >
                  <span className="font-heading font-bold text-accent-500">
                    {String((index % hotTopics.length) + 1).padStart(2, "0")}
                  </span>
                  {text}
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}